import { render, staticRenderFns } from "./OwnerDashboardNavbar.vue?vue&type=template&id=2b354ef7&"
import script from "./OwnerDashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./OwnerDashboardNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports